export default __webpack_public_path__ + "static/media/logo.23167130.png";